<template>
  <tr
    v-if="value || editMode && editable"
    class="detail"
  >
    <td class="label">{{ label }}:</td>
    <td class="value">
      <template v-if="editMode && editable">
        <yes-no
          v-if="type === 'binary'"
          class="yes-no"
          v-model="modelValue"
          :options="{0: $t('NO'), 1: $t('YES')}"
        />
        <editable-line
          v-else
          :class="{
            value__input: editMode
          }"
          v-model="modelValue"
          :type="type"
          :options="options"
          :field="field"
        />
      </template>
      <router-link v-else-if="filter || filterable" :to="filterLink">{{ value }}</router-link>
      <slot v-else>{{ value }}</slot>
    </td>
  </tr>
</template>

<script>
import detailsViewMixin from '@/mixins/detailsView.js';
import EditableLine from './EditableLine.vue';
import YesNo from '../../../components/YesNo.vue';

export default {
  mixins: [detailsViewMixin],
  components: { EditableLine, YesNo },
  props: {
    label: String,
    value: [String, Number],
    editable: Boolean,
    type: String,
    options: Array,
    field: String,
    filterable: Boolean,
    filter: Object,
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    filterLink() {
      if (this.filter) {
        return {
          path: '/',
          query: this.filter,
        };
      }

      return {
        path: '/',
        query: {
          [this.field]: this.value,
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.detail {
  line-height: 20px;
}

.label {
  color: var(--text-primary);
  font-weight: 600;
  padding-right: 15px;
  padding-bottom: 5px;
  vertical-align: middle;
}

.value {
  padding-bottom: 5px;
  vertical-align: middle;

  &__input {
    width: 220px;
  }
}

.yes-no {
  display: inline-flex;
}
</style>
